import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden" data-id="element-78">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-dark-900 z-0" data-id="element-79"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-gold-500/10 blur-[120px] rounded-full z-0 pointer-events-none" data-id="element-80"></div>

      <div className="relative z-10 max-w-6xl mx-auto w-full grid lg:grid-cols-2 gap-12 items-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-82">
          <div className="inline-block border border-gold-500/30 bg-gold-500/10 text-gold-400 font-semibold tracking-widest uppercase text-xs md:text-sm py-1.5 px-4 rounded-full mb-6" data-id="element-83">
            El Protocolo de 21 Días
          </div>
          <h1 className="font-oswald text-5xl md:text-6xl lg:text-7xl font-bold text-white uppercase tracking-tight leading-[1.1] mb-6" data-id="element-84">
            Hombre Apagado{' '}
            <span className="text-gold-500 block mt-2" data-id="element-85">No Más</span>
          </h1>
          <h2 className="text-lg md:text-xl text-zinc-400 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-86">
            Deja de arrastrarte por la vida y recupera la energía, el enfoque y
            la virilidad que el estilo de vida moderno te robó.
          </h2>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-87">
            <CTAButton href="#oferta" data-id="element-88">¡Quiero volver a encenderme!</CTAButton>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-89">
          <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-transparent to-transparent z-10 lg:hidden" data-id="element-90"></div>
          <motion.img animate={{
          y: [0, -15, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/9h8seUYueD9nPUJzA8E2d7/portada_hombre_apagado_nunca_mas.png" alt="Hombre Apagado No Más - Protocolo de 21 Días" className="w-full h-auto object-contain drop-shadow-[0_20px_50px_rgba(212,165,116,0.15)] relative z-0" data-id="element-91" />
        </motion.div>
      </div>
    </section>;
};